import { combineReducers } from 'redux';
import blazer from './blazer'
import shirt from './shirt'
import suit from './suit'
import vest from './vest'
export default combineReducers({
    blazer,
    shirt,
    suit,
    vest
});